var map = {
	".": [
		"./lngProvider/index.js",
		9
	],
	"./": [
		"./lngProvider/index.js",
		9
	],
	"./Print": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"./Print/": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"./Print/index": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"./Print/index.js": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"./data": [
		"./lngProvider/data/index.js",
		9
	],
	"./data/": [
		"./lngProvider/data/index.js",
		9
	],
	"./data/index": [
		"./lngProvider/data/index.js",
		9
	],
	"./data/index.js": [
		"./lngProvider/data/index.js",
		9
	],
	"./entries/da-DA": [
		"./lngProvider/entries/da-DA.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_da_DA_json",
		"lngProvider_entries_da-DA_js"
	],
	"./entries/da-DA.js": [
		"./lngProvider/entries/da-DA.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_da_DA_json",
		"lngProvider_entries_da-DA_js"
	],
	"./entries/de-DE": [
		"./lngProvider/entries/de-DE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_de_DE_json",
		"lngProvider_entries_de-DE_js"
	],
	"./entries/de-DE.js": [
		"./lngProvider/entries/de-DE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_de_DE_json",
		"lngProvider_entries_de-DE_js"
	],
	"./entries/en-US": [
		"./lngProvider/entries/en-US.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_en_US_json",
		"lngProvider_entries_en-US_js"
	],
	"./entries/en-US.js": [
		"./lngProvider/entries/en-US.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_en_US_json",
		"lngProvider_entries_en-US_js"
	],
	"./entries/es-ES": [
		"./lngProvider/entries/es-ES.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_es_ES_json",
		"lngProvider_entries_es-ES_js"
	],
	"./entries/es-ES.js": [
		"./lngProvider/entries/es-ES.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_es_ES_json",
		"lngProvider_entries_es-ES_js"
	],
	"./entries/et-ET": [
		"./lngProvider/entries/et-ET.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_et_ET_json",
		"lngProvider_entries_et-ET_js"
	],
	"./entries/et-ET.js": [
		"./lngProvider/entries/et-ET.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_et_ET_json",
		"lngProvider_entries_et-ET_js"
	],
	"./entries/fi-FI": [
		"./lngProvider/entries/fi-FI.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fi_FI_json",
		"lngProvider_entries_fi-FI_js"
	],
	"./entries/fi-FI.js": [
		"./lngProvider/entries/fi-FI.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fi_FI_json",
		"lngProvider_entries_fi-FI_js"
	],
	"./entries/fr-FR": [
		"./lngProvider/entries/fr-FR.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fr_FR_json",
		"lngProvider_entries_fr-FR_js"
	],
	"./entries/fr-FR.js": [
		"./lngProvider/entries/fr-FR.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fr_FR_json",
		"lngProvider_entries_fr-FR_js"
	],
	"./entries/it-IT": [
		"./lngProvider/entries/it-IT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_it_IT_json",
		"lngProvider_entries_it-IT_js"
	],
	"./entries/it-IT.js": [
		"./lngProvider/entries/it-IT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_it_IT_json",
		"lngProvider_entries_it-IT_js"
	],
	"./entries/lt-LT": [
		"./lngProvider/entries/lt-LT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_lt_LT_json",
		"lngProvider_entries_lt-LT_js"
	],
	"./entries/lt-LT.js": [
		"./lngProvider/entries/lt-LT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_lt_LT_json",
		"lngProvider_entries_lt-LT_js"
	],
	"./entries/nl-NL": [
		"./lngProvider/entries/nl-NL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_nl_NL_json",
		"lngProvider_entries_nl-NL_js"
	],
	"./entries/nl-NL.js": [
		"./lngProvider/entries/nl-NL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_nl_NL_json",
		"lngProvider_entries_nl-NL_js"
	],
	"./entries/no-NO": [
		"./lngProvider/entries/no-NO.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_no_NO_json",
		"lngProvider_entries_no-NO_js"
	],
	"./entries/no-NO.js": [
		"./lngProvider/entries/no-NO.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_no_NO_json",
		"lngProvider_entries_no-NO_js"
	],
	"./entries/pl-PL": [
		"./lngProvider/entries/pl-PL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pl_PL_json",
		"lngProvider_entries_pl-PL_js"
	],
	"./entries/pl-PL.js": [
		"./lngProvider/entries/pl-PL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pl_PL_json",
		"lngProvider_entries_pl-PL_js"
	],
	"./entries/pt-PT": [
		"./lngProvider/entries/pt-PT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pt_PT_json",
		"lngProvider_entries_pt-PT_js"
	],
	"./entries/pt-PT.js": [
		"./lngProvider/entries/pt-PT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pt_PT_json",
		"lngProvider_entries_pt-PT_js"
	],
	"./entries/se-SE": [
		"./lngProvider/entries/se-SE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_se_SE_json",
		"lngProvider_entries_se-SE_js"
	],
	"./entries/se-SE.js": [
		"./lngProvider/entries/se-SE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_se_SE_json",
		"lngProvider_entries_se-SE_js"
	],
	"./index": [
		"./lngProvider/index.js",
		9
	],
	"./index.js": [
		"./lngProvider/index.js",
		9
	],
	"./locales/da_DA.json": [
		"./lngProvider/locales/da_DA.json",
		3,
		"default-lngProvider_locales_da_DA_json"
	],
	"./locales/de_DE.json": [
		"./lngProvider/locales/de_DE.json",
		3,
		"default-lngProvider_locales_de_DE_json"
	],
	"./locales/en_US.json": [
		"./lngProvider/locales/en_US.json",
		3,
		"default-lngProvider_locales_en_US_json"
	],
	"./locales/es_ES.json": [
		"./lngProvider/locales/es_ES.json",
		3,
		"default-lngProvider_locales_es_ES_json"
	],
	"./locales/et_ET.json": [
		"./lngProvider/locales/et_ET.json",
		3,
		"default-lngProvider_locales_et_ET_json"
	],
	"./locales/fi_FI.json": [
		"./lngProvider/locales/fi_FI.json",
		3,
		"default-lngProvider_locales_fi_FI_json"
	],
	"./locales/fr_FR.json": [
		"./lngProvider/locales/fr_FR.json",
		3,
		"default-lngProvider_locales_fr_FR_json"
	],
	"./locales/it_IT.json": [
		"./lngProvider/locales/it_IT.json",
		3,
		"default-lngProvider_locales_it_IT_json"
	],
	"./locales/lt_LT.json": [
		"./lngProvider/locales/lt_LT.json",
		3,
		"default-lngProvider_locales_lt_LT_json"
	],
	"./locales/nl_NL.json": [
		"./lngProvider/locales/nl_NL.json",
		3,
		"default-lngProvider_locales_nl_NL_json"
	],
	"./locales/no_NO.json": [
		"./lngProvider/locales/no_NO.json",
		3,
		"default-lngProvider_locales_no_NO_json"
	],
	"./locales/pl_PL.json": [
		"./lngProvider/locales/pl_PL.json",
		3,
		"default-lngProvider_locales_pl_PL_json"
	],
	"./locales/pt_PT.json": [
		"./lngProvider/locales/pt_PT.json",
		3,
		"default-lngProvider_locales_pt_PT_json"
	],
	"./locales/se_SE.json": [
		"./lngProvider/locales/se_SE.json",
		3,
		"default-lngProvider_locales_se_SE_json"
	],
	"lngProvider": [
		"./lngProvider/index.js",
		9
	],
	"lngProvider/": [
		"./lngProvider/index.js",
		9
	],
	"lngProvider/Print": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"lngProvider/Print/": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"lngProvider/Print/index": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"lngProvider/Print/index.js": [
		"./lngProvider/Print/index.js",
		9,
		"lngProvider_Print_index_js"
	],
	"lngProvider/data": [
		"./lngProvider/data/index.js",
		9
	],
	"lngProvider/data/": [
		"./lngProvider/data/index.js",
		9
	],
	"lngProvider/data/index": [
		"./lngProvider/data/index.js",
		9
	],
	"lngProvider/data/index.js": [
		"./lngProvider/data/index.js",
		9
	],
	"lngProvider/entries/da-DA": [
		"./lngProvider/entries/da-DA.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_da_DA_json",
		"lngProvider_entries_da-DA_js"
	],
	"lngProvider/entries/da-DA.js": [
		"./lngProvider/entries/da-DA.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_da_DA_json",
		"lngProvider_entries_da-DA_js"
	],
	"lngProvider/entries/de-DE": [
		"./lngProvider/entries/de-DE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_de_DE_json",
		"lngProvider_entries_de-DE_js"
	],
	"lngProvider/entries/de-DE.js": [
		"./lngProvider/entries/de-DE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_de_DE_json",
		"lngProvider_entries_de-DE_js"
	],
	"lngProvider/entries/en-US": [
		"./lngProvider/entries/en-US.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_en_US_json",
		"lngProvider_entries_en-US_js"
	],
	"lngProvider/entries/en-US.js": [
		"./lngProvider/entries/en-US.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_en_US_json",
		"lngProvider_entries_en-US_js"
	],
	"lngProvider/entries/es-ES": [
		"./lngProvider/entries/es-ES.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_es_ES_json",
		"lngProvider_entries_es-ES_js"
	],
	"lngProvider/entries/es-ES.js": [
		"./lngProvider/entries/es-ES.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_es_ES_json",
		"lngProvider_entries_es-ES_js"
	],
	"lngProvider/entries/et-ET": [
		"./lngProvider/entries/et-ET.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_et_ET_json",
		"lngProvider_entries_et-ET_js"
	],
	"lngProvider/entries/et-ET.js": [
		"./lngProvider/entries/et-ET.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_et_ET_json",
		"lngProvider_entries_et-ET_js"
	],
	"lngProvider/entries/fi-FI": [
		"./lngProvider/entries/fi-FI.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fi_FI_json",
		"lngProvider_entries_fi-FI_js"
	],
	"lngProvider/entries/fi-FI.js": [
		"./lngProvider/entries/fi-FI.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fi_FI_json",
		"lngProvider_entries_fi-FI_js"
	],
	"lngProvider/entries/fr-FR": [
		"./lngProvider/entries/fr-FR.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fr_FR_json",
		"lngProvider_entries_fr-FR_js"
	],
	"lngProvider/entries/fr-FR.js": [
		"./lngProvider/entries/fr-FR.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_fr_FR_json",
		"lngProvider_entries_fr-FR_js"
	],
	"lngProvider/entries/it-IT": [
		"./lngProvider/entries/it-IT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_it_IT_json",
		"lngProvider_entries_it-IT_js"
	],
	"lngProvider/entries/it-IT.js": [
		"./lngProvider/entries/it-IT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_it_IT_json",
		"lngProvider_entries_it-IT_js"
	],
	"lngProvider/entries/lt-LT": [
		"./lngProvider/entries/lt-LT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_lt_LT_json",
		"lngProvider_entries_lt-LT_js"
	],
	"lngProvider/entries/lt-LT.js": [
		"./lngProvider/entries/lt-LT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_lt_LT_json",
		"lngProvider_entries_lt-LT_js"
	],
	"lngProvider/entries/nl-NL": [
		"./lngProvider/entries/nl-NL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_nl_NL_json",
		"lngProvider_entries_nl-NL_js"
	],
	"lngProvider/entries/nl-NL.js": [
		"./lngProvider/entries/nl-NL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_nl_NL_json",
		"lngProvider_entries_nl-NL_js"
	],
	"lngProvider/entries/no-NO": [
		"./lngProvider/entries/no-NO.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_no_NO_json",
		"lngProvider_entries_no-NO_js"
	],
	"lngProvider/entries/no-NO.js": [
		"./lngProvider/entries/no-NO.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_no_NO_json",
		"lngProvider_entries_no-NO_js"
	],
	"lngProvider/entries/pl-PL": [
		"./lngProvider/entries/pl-PL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pl_PL_json",
		"lngProvider_entries_pl-PL_js"
	],
	"lngProvider/entries/pl-PL.js": [
		"./lngProvider/entries/pl-PL.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pl_PL_json",
		"lngProvider_entries_pl-PL_js"
	],
	"lngProvider/entries/pt-PT": [
		"./lngProvider/entries/pt-PT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pt_PT_json",
		"lngProvider_entries_pt-PT_js"
	],
	"lngProvider/entries/pt-PT.js": [
		"./lngProvider/entries/pt-PT.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_pt_PT_json",
		"lngProvider_entries_pt-PT_js"
	],
	"lngProvider/entries/se-SE": [
		"./lngProvider/entries/se-SE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_se_SE_json",
		"lngProvider_entries_se-SE_js"
	],
	"lngProvider/entries/se-SE.js": [
		"./lngProvider/entries/se-SE.js",
		9,
		"defaultVendors-node_modules_formatjs_intl-pluralrules_polyfill_js-node_modules_formatjs_intl--9f4377",
		"default-lngProvider_locales_se_SE_json",
		"lngProvider_entries_se-SE_js"
	],
	"lngProvider/index": [
		"./lngProvider/index.js",
		9
	],
	"lngProvider/index.js": [
		"./lngProvider/index.js",
		9
	],
	"lngProvider/locales/da_DA.json": [
		"./lngProvider/locales/da_DA.json",
		3,
		"default-lngProvider_locales_da_DA_json"
	],
	"lngProvider/locales/de_DE.json": [
		"./lngProvider/locales/de_DE.json",
		3,
		"default-lngProvider_locales_de_DE_json"
	],
	"lngProvider/locales/en_US.json": [
		"./lngProvider/locales/en_US.json",
		3,
		"default-lngProvider_locales_en_US_json"
	],
	"lngProvider/locales/es_ES.json": [
		"./lngProvider/locales/es_ES.json",
		3,
		"default-lngProvider_locales_es_ES_json"
	],
	"lngProvider/locales/et_ET.json": [
		"./lngProvider/locales/et_ET.json",
		3,
		"default-lngProvider_locales_et_ET_json"
	],
	"lngProvider/locales/fi_FI.json": [
		"./lngProvider/locales/fi_FI.json",
		3,
		"default-lngProvider_locales_fi_FI_json"
	],
	"lngProvider/locales/fr_FR.json": [
		"./lngProvider/locales/fr_FR.json",
		3,
		"default-lngProvider_locales_fr_FR_json"
	],
	"lngProvider/locales/it_IT.json": [
		"./lngProvider/locales/it_IT.json",
		3,
		"default-lngProvider_locales_it_IT_json"
	],
	"lngProvider/locales/lt_LT.json": [
		"./lngProvider/locales/lt_LT.json",
		3,
		"default-lngProvider_locales_lt_LT_json"
	],
	"lngProvider/locales/nl_NL.json": [
		"./lngProvider/locales/nl_NL.json",
		3,
		"default-lngProvider_locales_nl_NL_json"
	],
	"lngProvider/locales/no_NO.json": [
		"./lngProvider/locales/no_NO.json",
		3,
		"default-lngProvider_locales_no_NO_json"
	],
	"lngProvider/locales/pl_PL.json": [
		"./lngProvider/locales/pl_PL.json",
		3,
		"default-lngProvider_locales_pl_PL_json"
	],
	"lngProvider/locales/pt_PT.json": [
		"./lngProvider/locales/pt_PT.json",
		3,
		"default-lngProvider_locales_pt_PT_json"
	],
	"lngProvider/locales/se_SE.json": [
		"./lngProvider/locales/se_SE.json",
		3,
		"default-lngProvider_locales_se_SE_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./lngProvider lazy recursive ^.*$";
module.exports = webpackAsyncContext;